import { render, staticRenderFns } from "./kids_class_new.vue?vue&type=template&id=7beb996a&scoped=true&"
import script from "./kids_class_new.vue?vue&type=script&lang=js&"
export * from "./kids_class_new.vue?vue&type=script&lang=js&"
import style0 from "./kids_class_new.vue?vue&type=style&index=0&id=7beb996a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7beb996a",
  null
  
)

export default component.exports